/**
 * Removes free-gift line items when the cart no longer qualifies.
 * Cart drawer/page `updateQuantity` also merges these removals into the same
 * mutation; this controller covers other cart sources as a safety net.
 */
(function (global) {
  if (global.freeGiftController) return;

  const SOURCE = 'free-gift-controller';
  let busy = false;

  function offers() {
    if (Array.isArray(global.freeGiftOffers) && global.freeGiftOffers.length) {
      return global.freeGiftOffers;
    }
    const el = document.getElementById('FreeGiftOffersJson');
    if (!el) return [];
    try {
      const parsed = JSON.parse(el.textContent);
      const list = Array.isArray(parsed) ? parsed : [];
      global.freeGiftOffers = list;
      return list;
    } catch (e) {
      return [];
    }
  }

  function cartUrl() {
    return (global.routes && global.routes.cart_url) || '/cart';
  }

  function updateUrl() {
    return (global.routes && global.routes.cart_update_url) || '/cart/update.js';
  }

  async function fetchCart() {
    const response = await fetch(`${cartUrl()}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) return null;
    return response.json();
  }

  async function reconcile(cart) {
    const Shared = global.FreeGiftShared;
    const list = offers();
    if (!Shared || !list.length || busy) return false;

    const current = cart?.items ? cart : await fetchCart();
    if (!current?.items) return false;

    const updates = Shared.getOrphanedGiftUpdates(current, list);
    if (!Object.keys(updates).length) return false;

    busy = true;
    try {
      const response = await fetch(updateUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
      if (!response.ok) return false;
      const next = await response.json();
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: next });
      }
      return true;
    } finally {
      busy = false;
    }
  }

  function bind() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source === SOURCE) return;
      const cart = event?.cartData?.items ? event.cartData : null;
      reconcile(cart);
    });
    reconcile();
  }

  global.freeGiftController = { reconcile, SOURCE };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})(typeof window !== 'undefined' ? window : globalThis);
